<template>
  <main
    class="default default__preFooterGap default__blob default__blob--generic"
  >
    <section class="default__infoContent default__sitePad">
      <IconRabbit
        class="icon icon--light-gray icon--ultra-large layout--margin-bottom-md"
      />
      <h1 class="default__title layout--margin-bottom-xxs">
        Oops, that page doesn't exist.
      </h1>
      <p class="layout--margin-bottom-sm default__paragraphSmall">
        Please
        <a class="link" href="mailto:info@motionmailapp.com">send a message</a>
        if you're unable to find what you're looking for.
      </p>
      <p class="default__gray layout--margin-bottom-lg">
        404 Page Not Found
      </p>
      <router-link
        v-if="loggedIn"
        to="dashboard overview"
        class="button button--big layout--inline-block"
      >
        Go to Dashboard
      </router-link>
      <a v-else href="/" class="button button--big layout--inline-block">
        Go to Homepage
      </a>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { RouterLink } from "vue-router";
import IconRabbit from "../assets/icons/iconWhiteRabbit.svg";

export default {
  name: "default",
  components: {
    IconRabbit,
  },
  computed: {
    ...mapGetters("session", ["loggedIn"]),
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/pages/_default.scss";
</style>
